import React, { useEffect, useState } from "react";

export const LinkageIdInput = ({
  formApi,
  input,
  data,
  row, // row index for inline modal item
  schemaProps: {
    machine_name,
    linkages: { linkageIdPrefix = "" },
    hidden,
  },
}) => {
  const [idNumber, setIdNumber] = useState(1);

  // Extract numerics
  const extractNumericId = (alphanumericId) => {
    const extractedId = alphanumericId?.replace(linkageIdPrefix, "");
    return parseInt(extractedId, 10);
  };

  // Calculate and set Id number
  const handleSetIdNumber = (data = []) => {
    const existingId = data?.[row]?.[machine_name];
    const latestId = data?.[data.length - 1]?.[machine_name];

    if (existingId) {
      // Reuse exising ID; Set extracted number id
      setIdNumber(extractNumericId(existingId));
    } else if (latestId) {
      // Generate new ID
      setIdNumber(extractNumericId(latestId) + 1);
    }
  };

  // Set id number
  useEffect(() => {
    !!data?.length && handleSetIdNumber(data);
  }, [data]);

  const completeId = `${linkageIdPrefix}${idNumber}`;

  // Update id field values
  useEffect(() => {
    formApi.change(`add_values_field[0][${machine_name}]`, completeId);
  }, [idNumber]);

  return (
    !hidden && (
      <input
        {...input}
        disabled={true}
        className={`${machine_name} usa-input usa-input-disabled`}
        value={completeId}
      />
    )
  );
};
